import { useQuery } from "@tanstack/react-query";
import PropTypes from "prop-types";
import bksAPI from "api/bks";
import { useAuth0 } from "@auth0/auth0-react";
import SoftBox from "components/SoftBox";

function wrapper(content) {
    return (
        <SoftBox>
            {content}
        </SoftBox>
    )
}

function LatestCameraImage({ device_uuid }) {

    bksAPI.loadToken(useAuth0());

    const currentCameraImage = useQuery({
        queryKey: ['getCameraFeed', device_uuid],
        queryFn: async () => {
            return await bksAPI.getCameraFeed(device_uuid);
        },
        refetchInterval: 20 * 1000,
    });

    if (currentCameraImage.isLoading) {
        return wrapper("Loading...");
    }

    if (currentCameraImage.error) {
        return wrapper("Error! " + currentCameraImage.error.message);
    }

    // console.log('new_image')
    const blob = new Blob([currentCameraImage.data]);
    const current_camera_img = URL.createObjectURL(blob);

    return (
        <SoftBox
            component="img"
            src={current_camera_img}
            position="relative"
            maxWidth="100%"
            height="100%"
            borderRadius="lg"
        />
    );
}

LatestCameraImage.propTypes = {
    device_uuid: PropTypes.string,
}

export default LatestCameraImage;